module.exports = __webpack_public_path__ + "fonts/SuisseIntl-BoldItalic.0184256.woff2";